import React from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
// import cn from "classnames";

import styles from './settings.css';
import Page from '../../components/page/page';
import bindAll from "lodash.bindall";

import { setUser } from '../../reducers/teach';
import { update, cnPerformance, me, getInquiryCode } from '../../api/user';
import message from "../../components/message/message";
import ModalManager from "../../components/modal/modal-manager";
import { showLoading } from "../../components/loading/loading";
import AccountResModal from "../../components/account-res-modal/account-res-modal";
import PageContentMargin from "../../components/page-content-margin/page-content-margin";
import TipsModal from './tipsModal';
import QRcode from '../../h5/register/images/code.png';
import dataURItoBlob from '../../../lib/data-uri-to-blob';
import { post } from '../../api/api';
import copy from 'copy-to-clipboard';


class SettingPage extends React.PureComponent {

    constructor(props) {
        super(props);
        bindAll(this, [
            'getTicket',
            'getCN',
            'promote',
            'inquiryCode',
            'copyClipboard',
            'statistics'
        ]);
        this.state = {
            img: null,
            CN: {},
            discountCode: null
        }
    }

    componentDidMount() {
        this.getUser();
        this.getTicket();
        this.getCN();
        this.inquiryCode();
    }

    getUser() {
        me({}, { quiet: !!this.props.username }).then(res => {
            this.props.setUser(res)
        });
    }

    // 获取渠道优惠码
    inquiryCode() {
        getInquiryCode({}, { quiet: !!this.props.username }).then(res => {
            if (res) {
                this.setState({ discountCode: res.code })
            }
        });
    }

    //手机号隐藏处理
    getTel(tel) {
        if (tel) {
            if (tel.length === 12) {
                const reg = /^(\d{3})\d{4}(\d{5})$/;
                return tel.replace(reg, "$1****$2");
            }
            const reg = /^(\d{3})\d{4}(\d{4})$/;
            return tel.replace(reg, "$1****$2");
        }
    }

    //获取渠道二维码
    getTicket() {
        const { user } = this.props
        axios.defaults.headers['api-token'] = localStorage.getItem('api-token')
        axios.get(`${window.config.apiBaseURL}/weixin/get-qrcode?type=${Number(user.role) === 2 ? 'QR_LIMIT_SCENE' : user.ct > 0 ? 'QR_LIMIT_SCENE' : 'QR_SCENE'}`).then(res => {
            const { data } = res
            this.setState({
                img: `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${data.msg.ticket}`
            })
        })
    }

    //获取渠道号
    getCN() {
        cnPerformance({}, { quiet: !!this.props.user.id }).then(res => {
            this.setState({
                CN: res
            })
        });
    }

    handleClick(page) {
        const { setUser } = this.props;
        ModalManager.open(AccountResModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            setUser, showLoading, page
        }, 'change');
    }

    handleChange() {
        const { user } = this.props;
        ModalManager.open(TipsModal, {
            closeAfterSubmit: true,
            onClose: () => { },
            onSetId: async () => {
                try {
                    let users = await update({
                        role: user.role == 1 ? 2 : 1,
                    });
                    ModalManager.pop()
                    this.props.setUser(users);
                    message.show(window.L('teach.user.changeSuccess'));
                    if (user.role == 1) {
                        this.props.history.push('/helper');
                    }
                } catch (error) {
                    // eslint-disable-next-line no-alert
                    if (error.msg || error.data) {
                        message.show(error.msg.name || error.data);
                    } else {
                        message.show(error.toString());
                    }
                }
            },
            showLoading, user
        });
    }

    async handleImgSubmit(data) {
        try {
            let user = await update({
                avatar: data,
            });
            this.props.setUser(user);
            message.show(window.L('teach.user.saveSuccess'));
        } catch (error) {
            // eslint-disable-next-line no-alert
            if (error.msg || error.data) {
                message.show(error.msg.name || error.data);
            } else {
                message.show(error.toString());
            }
        }
    }

    handleUpdateProjectThumbnail(userId, data) {
        post('oss/avatar/' + userId + '.png', { quiet: true })(data).then(res => {
            const timestamp = new Date().getTime()
            const imgUrl = `${userId}.png?timestamp=${timestamp}`
            this.handleImgSubmit(imgUrl)
        });
    }

    uploadHeadImg(e) {
        const self = this;
        const { user } = this.props
        let base64head = '';
        const file = e.currentTarget.files[0];
        const reader = new FileReader();

        if (file) {
            reader.readAsDataURL(file);
        }
        reader.onload = function (item) {
            base64head = item.target.result;
            self.handleUpdateProjectThumbnail(user.id, dataURItoBlob(base64head))
        }
    }

    promote() {
        this.props.history.push('/promote')
    }

    copyClipboard(){
        const {discountCode}=this.state
        // window.clipboardData.setData("Text",'1234');
        copy(`${window.config.baseURL}/vip/sub?code=${discountCode}`)
        message.show('复制成功');
    }

    statistics() {
        this.props.history.push('/statistics')
    }

    render() {
        const { user } = this.props;
        const { img, CN, discountCode } = this.state;
        return (
            <Page isModal={true} title={window.L("teach.user.settings")}>
                <PageContentMargin>
                    <div className={styles.accountBox}>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>头像</p>
                            </div>
                            <div className={styles.userImg}>
                                <img src={window.config.staticURL + '/avatar/' + (user.avatar || 'default.png')} />
                                <div className={styles.upload}>
                                    <span>编辑</span>
                                    <input type="file" accept="image/*" title="" onChange={e => this.uploadHeadImg(e)} />
                                </div>
                            </div>
                        </div>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>用户名</p>{user.name}
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.handleClick(2)}>{window.L('teach.button.change')}</button>
                        </div>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>手机号</p>{this.getTel(user.phone)}
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.handleClick(0)}>{window.L('teach.button.change')}</button>
                        </div>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>登录密码</p>**********
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.handleClick(1)}>{window.L('teach.button.change')}</button>
                        </div>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>当前身份</p>
                                {user.role && user.role == 1 ? '学生' : '老师'}
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.handleChange()}>
                                {user.role == 1 ? ("切换为老师") : ("切换为学生")}
                                {/* {window.L('teach.button.change')} */}
                            </button>
                        </div>
                        {/* {
                            CN.cn || CN.cn === 0 ? (
                                <div className={styles.accountItem}>
                                    <div className={styles.defaultValue}>
                                        <p>渠道号</p>
                                        {CN.cn}
                                    </div>
                                </div>
                            ) : null
                        } */}
                        {
                            CN.my_count || CN.my_count === 0 ? (
                                <div className={styles.accountItem}>
                                    <div className={styles.defaultValue}>
                                        <p>个人推广数量</p>
                                        {CN.my_count}
                                    </div>
                                </div>
                            ) : null
                        }
                        {
                            CN.cn_count || CN.cn_count === 0 ? (
                                <div className={styles.accountItem}>
                                    <div className={styles.defaultValue}>
                                        <p>渠道总推广数量</p>
                                        {CN.cn_count}
                                    </div>
                                </div>
                            ) : null
                        }
                        {/* <div className={styles.accountItem}>
                        {/*<div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>推广收入</p>
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.promote()}>
                                查看
                            </button>
                        </div> */}
                        {
                            discountCode ? (
                                <div className={styles.accountItem}>
                                    <div className={styles.defaultValue}>
                                        <p>渠道码</p>
                                        {discountCode}
                                    </div>
                                </div>
                            ) : (null)
                        }
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>会员支付链接</p>
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.copyClipboard()}>
                                复制
                            </button>
                        </div>
                        <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>{Number(user.role) === 2 ? '永久渠道二维码' : user.ct > 0 ? '永久渠道二维码' : '临时渠道二维码'}</p>
                            </div>
                            <div>
                                <img className={styles.qrcodeLogo} src={QRcode}></img>
                                <div className={styles.qrcode}>
                                    <img src={img}></img>
                                    <p>{Number(user.role) === 2 ? '永久渠道二维码' : user.ct > 0 ? '永久渠道二维码' : '临时渠道二维码'}</p>
                                </div>
                            </div>
                        </div>
                        { user.ct > 0 && <div className={styles.accountItem}>
                            <div className={styles.defaultValue}>
                                <p>推广统计</p>
                            </div>
                            <button className={styles.changeBtn} onClick={() => this.statistics()}>
                                查看
                            </button>
                        </div>}
                    </div>
                </PageContentMargin>
            </Page>
        );
    }
}


const mapStateToProps = state => ({
    user: state.teach.user
});


const mapDispatchToProps = dispatch => ({
    setUser: res => dispatch(setUser(res))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingPage);
